module.exports = __webpack_public_path__ + "static/sanxing-2c102f5ebed92c337dd66220db4a0ff7.png";